import React from "react";

export function ErrorMessage({
  id,
  children,
}: {
  id: string | undefined; // To be forced to explicitly disable with `id={undefined}`
  children: React.ReactChild;
}) {
  return (
    <p
      role="alert"
      id={id ? `${id}-error` : undefined}
      data-testid={id ? `${id}-error` : undefined}
      className="tw-m-0 tw-mt-2 tw-text-red-600"
    >
      {children}
    </p>
  );
}
